// src/assets/profile-emojis/index.ts
import animoji1 from './animoji-1.png';
import animoji2 from './animoji-2.png';
import animoji3 from './animoji-3.png';
import animoji4 from './animoji-4.png';
import animoji5 from './animoji-5.png';
import animoji6 from './animoji-6.png';
import animoji7 from './animoji-7.png';
import animoji8 from './animoji-8.png';
import animoji9 from './animoji-9.png';
import animoji10 from './animoji-10.png';
import animoji11 from './animoji-11.png';
import animoji12 from './animoji-12.png';
import animoji13 from './animoji-13.png';
import animoji14 from './animoji-14.png';
import animoji15 from './animoji-15.png';
import animoji16 from './animoji-16.png';
import animoji17 from './animoji-17.png';
import animoji18 from './animoji-18.png';
import animoji19 from './animoji-19.png';
import animoji20 from './animoji-20.png';
import animoji21 from './animoji-21.png';
import animoji22 from './animoji-22.png';
import animoji23 from './animoji-23.png';
import animoji24 from './animoji-24.png';
import animoji25 from './animoji-25.png';
import animoji26 from './animoji-26.png';
import animoji27 from './animoji-27.png';
import animoji28 from './animoji-28.png';
import animoji29 from './animoji-29.png';
import animoji30 from './animoji-30.png';
import animoji31 from './animoji-31.png';
import animoji32 from './animoji-32.png';
import animoji33 from './animoji-33.png';
import animoji34 from './animoji-34.png';
import animoji35 from './animoji-35.png';
import animoji36 from './animoji-36.png';
import animoji37 from './animoji-37.png';
import animojiBase from './animoji.png';

export const allProfileEmojis = [
  animoji1,
  animoji2,
  animoji3,
  animoji4,
  animoji5,
  animoji6,
  animoji7,
  animoji8,
  animoji9,
  animoji10,
  animoji11,
  animoji12,
  animoji13,
  animoji14,
  animoji15,
  animoji16,
  animoji17,
  animoji18,
  animoji19,
  animoji20,
  animoji21,
  animoji22,
  animoji23,
  animoji24,
  animoji25,
  animoji26,
  animoji27,
  animoji28,
  animoji29,
  animoji30,
  animoji31,
  animoji32,
  animoji33,
  animoji34,
  animoji35,
  animoji36,
  animoji37,
  animojiBase,
];
